const partsRegex = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;
export function getUrlParts(url) {
    const result = partsRegex.exec(url);
    return {
        url: result[0],
        protocol: result[1],
        slash: result[2],
        host: result[3],
        port: result[4],
        path: result[5],
        query: result[6],
        hash: result[7],
    };
}
//# sourceMappingURL=url-parts.js.map